export default "__VITE_ASSET__lllgJGFH__"